import _objectSpread from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { memo } from "../util/index.js";
export function referendums(instanceId, api) {
  return memo(instanceId, function () {
    return api.derive.democracy.referendumsActive().pipe(switchMap(function (referendums) {
      return referendums.length ? combineLatest([of(referendums), api.derive.democracy._referendumsVotes(referendums)]) : of([[], []]);
    }), map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          referendums = _ref2[0],
          votes = _ref2[1];

      return referendums.map(function (referendum, index) {
        return _objectSpread(_objectSpread({}, referendum), votes[index]);
      });
    }));
  });
}